import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=0a5c537d&scoped=true"
import script from "./consent.vue?vue&type=script&lang=js"
export * from "./consent.vue?vue&type=script&lang=js"
import style0 from "./consent.vue?vue&type=style&index=0&id=0a5c537d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5c537d",
  null
  
)

export default component.exports